module.exports = __webpack_public_path__ + "img/zapier-logo.6a35a9d2.svg";